module.exports = __webpack_public_path__ + "img/feature5.2b5fe1f2.png";